var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";

export default function IconButton(props) {
    var _props$type = props.type,
        type = _props$type === undefined ? "default" : _props$type,
        icon = props.icon,
        className = props.className,
        otherProps = _objectWithoutProperties(props, ["type", "icon", "className"]);

    return React.createElement(
        "button",
        _extends({
            type: "button",
            className: "btn btn-" + type + " " + className
        }, otherProps),
        "Remove"
    );
}